import setBlockedDomainsOption from '../actions/setBlockedDomainsOption';
import BlockedDomainsOptionState from '../store/schema/BlockedDomainsOptionState';
import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { getFallbackValueIfNull } from 'owa-options-core';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import {
    EditSendersAndDomains,
    EditSendersAndDomainsMode,
    isEmailAddress,
} from 'owa-mail-option-common';
import { OptionDescription } from 'owa-options-controls';

export interface BlockedDomainsFullProps {
    optionState?: BlockedDomainsOptionState;
    junkEmailConfiguration?: MailboxJunkEmailConfigurationOptions;
}

@reactive({
    optionState: () => store,
    junkEmailConfiguration: () => getMailboxJunkEmailConfiguration(),
})
export default class BlockedDomainsFull extends React.Component<BlockedDomainsFullProps, {}> {
    render() {
        const domains = getFallbackValueIfNull(
            this.props.optionState.blockedDomains,
            this.props.junkEmailConfiguration.BlockedSendersAndDomains.filter(
                item => !isEmailAddress(item)
            )
        );

        return (
            <div>
                {domains && (
                    <div>
                        <OptionDescription>
                            {strings.options_junkEmail_blockedDomains}
                        </OptionDescription>
                        <EditSendersAndDomains
                            items={domains}
                            onItemsChanged={this.onChangeBlockedDomains}
                            mode={EditSendersAndDomainsMode.DomainOnly}
                        />
                    </div>
                )}
            </div>
        );
    }

    onChangeBlockedDomains = (blockedDomains: string[]) => {
        setBlockedDomainsOption(blockedDomains);
    };
}
